import { Dispatch } from 'redux'

import type { TAlertData } from 'redux/reducers/Applications/Alert'
import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function setAlert(data: TAlertData) {
  return (dispatch: Dispatch) => {
    dispatch(actions.set(data))
  }
}

export function resetAlert() {
  return (dispatch: Dispatch) => {
    dispatch(actions.reset())
  }
}

export const useAlertActions = () => {
  return {
    setAlert: useThunkActions(setAlert),
    resetAlert: useThunkActions(resetAlert)
  }
}
